import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postHolidayResponderFailure,
  postHolidayResponderSuccess,
} from "../slices/features/holidayResponder";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postHolidaySaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.postHolidayResponder,
      baseUrl,
      data,
      id
    );
    yield put(postHolidayResponderSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postHolidayResponderFailure({ statusCode, statusText }));
  }
}

export function* watchPostHolidayResponder() {
  yield takeLatest(RequestTypes.POST_HOLIDAY_AUTORESPONDER, postHolidaySaga);
}
